module.exports = __webpack_public_path__ + "static/media/menu_corner_upper_right.fa4ae9bc.png";